// Presentation-only helpers. Costs are calculated by the existing backend
// variant-costing engine; this merely chooses the correct card summary.
export const activeVariantSummaries = recipe => {
  const costingById = new Map((recipe?.variant_costing || []).map(item => [item.variant_id, item]));
  return (recipe?.output_variants || [])
    .filter(variant => variant.active !== false)
    .map(variant => ({ ...variant, ...(costingById.get(variant.id) || {}) }));
};

export const hasActiveVariants = recipe => activeVariantSummaries(recipe).length > 0;
